<mat-dialog-content>
    <div class="container-fluid p-0">
        <div class="row">
            <div class="col-md-12 text-center">
                <div class="list">
                    <div id="drop-zone">
                        <input #search_input class="search-box" style="z-index: 1001;display: inline-block;" type="text"
                            autocomplete="off" placeholder="{{'Search'}}" (keyup)="availableFilter($event)"
                            [formControl]="available_search">
                    </div>

                    <cdk-virtual-scroll-viewport #options_list_view
                        style="opacity: 1; pointer-events: auto;color: black;" itemSize="40"
                        class="viewport select-menu">
                        <ng-container *cdkVirtualFor="let option of (avl_filtered_options); let i = index">
                            <li class="select-options box"
                                *ngIf="option && !option.hidden && (suffix_btn_label || suffix_btn_icon) &&addFunc "
                                [value]="option[id_property]">
                                <span class="contents pointer" [ngClass]="{'draggable-content':enable_sorting}"
                                    (click)="onSelect(option,i,1)">
                                    {{ option[title_property]}}
                                </span>
                                <div *ngIf="suffix_btn_icon || suffix_btn_label" [class]="'contents-action ml-auto'">
                                    <button class="btn btn-sm btn-default mx-1" (click)="actionClicked(option)">
                                        <i *ngIf="suffix_btn_icon" class="fa {{suffix_btn_icon}} hgs-icon"></i>
                                        {{suffix_btn_label ||'SELECT.edit' |translate }}
                                    </button>
                                </div>
                            </li>
                            <li class="select-options pointer box"
                                *ngIf="option && !option.hidden && (!suffix_btn_label && !suffix_btn_icon) "
                                (click)="onSelect(option,i,1)" [value]="option[id_property]">
                                {{ option[title_property]}}
                            </li>
                        </ng-container>
                        <li *ngIf="avl_filtered_options == null || avl_filtered_options == undefined || avl_filtered_options.length == 0 "
                            class="select-options text-center no-data"> {{"SELECT.no_data_found" |translate}}</li>
                    </cdk-virtual-scroll-viewport>

                </div>
            </div>
        </div>
    </div>


</mat-dialog-content>